import sk from '../locales/sk.json';
import en from '../locales/en.json';
import de from '../locales/de.json';

const DICTS = { sk, en, de };

let currentLocale = 'sk';
let currentT = null;

export function setUiTranslator(t, locale = 'sk') {
  currentT = typeof t === 'function' ? t : null;
  currentLocale = DICTS[locale] ? locale : 'sk';
}

export function uiLocale() {
  return currentLocale;
}

function interpolateParams(template, params = null) {
  if (typeof template !== 'string' || !params || typeof params !== 'object') return template;
  return Object.entries(params).reduce((acc, [k, value]) => {
    const safeValue = value == null ? '' : String(value);
    return acc
      .replace(new RegExp(`\\{\\{\\s*${k}\\s*\\}\\}`, 'g'), safeValue)
      .replace(new RegExp(`:${k}\\b`, 'g'), safeValue);
  }, template);
}

export function uiT(key, params = null) {
  if (!key) return '';
  let translated;
  if (currentT) {
    translated = currentT(key, params);
    // If provider returns the raw key (missing in active locale), fall through to dict.
    if (translated != null && translated !== '' && translated !== key) {
      return translated;
    }
  }
  const dict = DICTS[currentLocale] || DICTS.sk;
  translated = dict[key] || DICTS.sk[key] || key;
  return interpolateParams(translated, params);
}
